import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Esta guía es solo para mujeres casadas?',
    a: 'No. También aplica para mujeres en convivencia o en una relación estable donde existe historia, rutina, vínculo y desgaste emocional acumulado.'
  }, {
    q: '¿La guía busca salvar el matrimonio?',
    a: 'Busca algo más importante primero: ayudarte a entender qué está pasando realmente. Desde ahí podrás ver con mayor claridad si hay algo que reconstruir o si necesitas aceptar verdades que has postergado.'
  }, {
    q: '¿Es para mí si no quiero separarme?',
    a: 'Sí. Está pensada precisamente para mujeres que no quieren actuar por impulso y necesitan comprensión antes que extremos.'
  }, {
    q: '¿Y si me da miedo confirmar lo que ya sospecho?',
    a: 'Es normal. Pero vivir en confusión prolonga el dolor. Entender lo que pasa te devuelve paz, orden y poder personal.'
  }, {
    q: '¿Voy a sentirme juzgada por lo que estoy viviendo?',
    a: 'No. Esta guía fue escrita para acompañarte con profundidad, respeto y sensibilidad.'
  }, {
    q: '¿La lectura es privada?',
    a: 'Sí. Es una guía pensada para que puedas leerla en tu espacio, a tu ritmo y con total intimidad.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-8 md:py-12 px-6 bg-[#F8F0F5]" data-id="element-120">
      <div className="max-w-3xl mx-auto" data-id="element-121">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-122">
          <h2 className="text-3xl md:text-4xl font-bold" data-id="element-123">
            PREGUNTAS FRECUENTES
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-124">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="border border-softGold/30 rounded-xl overflow-hidden bg-cream" data-id="element-125">
              <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-terracotta" aria-expanded={openIndex === index} data-id="element-126">
                <span className="font-heading font-bold text-lg text-warmBrown pr-4" data-id="element-127">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-terracotta transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-128" />
              </button>

              <AnimatePresence data-id="element-129">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-130">
                    <div className="px-6 pb-5 text-mutedBrown leading-relaxed" data-id="element-131">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}